
import {
  FETCH_STRATEGY_START,
  FETCH_STRATEGY_SUCCESS,
  FETCH_STRATEGY_ERROR,
  ADD_STRATEGY_START,
  ADD_STRATEGY_SUCCESS,
  ADD_STRATEGY_ERROR,
  ADD_STRATEGY_CLEAR,
  EDIT_STRATEGY_START,
  EDIT_STRATEGY_DONE,
  EDIT_STRATEGY_CLEAR,
  DELETE_STRATEGY_START,
  DELETE_STRATEGY_DONE,
  CHANGE_STATUS_STRATEGY_START,
  CHANGE_STATUS_STRATEGY_END
} from "./actionTypes";

const initialState = {
  loading:false,
  error:"",
  strategy:[],
  clearingCounter: 0,
  editClearingCounter: 0,
  deleteClearingCounter: 0,
  // totalDocs: 0,
  // docs: [],
  // page: 1
};
const leadReducer = (state = initialState, action)=>{
  switch (action.type){
    case FETCH_STRATEGY_START:
      state = {
        ...state,
        loading:true,
      };
      break;
    case FETCH_STRATEGY_SUCCESS:
      state = {
        ...state,
        strategy: [...action.payload.docs],
        totalDocs: action.payload.totalDocs,
        hasNextPage: action.payload.hasNextPage,
        hasPrevPage: action.payload.hasPrevPage,
        limit: action.payload.limit,
        nextPage: action.payload.nextPage,
        page: action.payload.page,
        pagingCounter: action.payload.pagingCounter,
        prevPage: action.payload.prevPage,
        totalPages: action.payload.totalPages,
        loading: false,
      };
      break;
    case FETCH_STRATEGY_ERROR:
      state = {
        ...state,
        loading: false,
        error:action.payload.error
      };
      break;
    
    case ADD_STRATEGY_START:
      state = {
        ...state,
        addLoading:true,
      };
      break;
    case ADD_STRATEGY_SUCCESS:
      state = {
        ...state,
        addResult: action.payload,
        strategy: [ action.payload, ...state.strategy ],
        addSuccess: true,
        addError: false,
        addLoading: false,
      };
      break;
    case ADD_STRATEGY_ERROR:
      state = {
        ...state,
        addLoading: false,
        addErrorDetails:action.payload,
        addSuccess: false,
        addError: true,
      };
      break;
    case ADD_STRATEGY_CLEAR:
      state = {
        ...state,
        addErrorDetails: "",
        addSuccess: false,
        addError: false,
        addResult: null,
        clearingCounter: state.clearingCounter + 1
      };
      break;
    
    case EDIT_STRATEGY_START:
      state = {
        ...state,
        editLoading:true,
      };
      break;
    case EDIT_STRATEGY_DONE:
      // eslint-disable-next-line no-case-declarations
      const { id, ...payload } = action.payload;
      state = {
        ...state,
        docs: state.docs.map(obj => {
          if (obj._id === id) {
            return {
              ...obj,
              title: payload.result.title,
              permissions: payload.result.permissions,
            };
          } else {
            return obj;
          }
        }),
        editLoading: false,
        editResult: action.payload.result,
        editError: action.payload.error,
      };
      break;
    case EDIT_STRATEGY_CLEAR:
      state = {
        ...state,
        editResult: null,
        editError: null,
        editClearingCounter: state.editClearingCounter + 1
      };
      break;
    case DELETE_STRATEGY_START:
      state = {
        ...state,
        deleteLoading:true,
      };
      break;
    case DELETE_STRATEGY_DONE:
      state = {
        ...state,
        docs: state.docs.filter(obj => obj._id !== action.payload.id),
        deleteLoading: false,
        deleteResult: action.payload.result,
        deleteError: action.payload.error,
        deleteClearingCounter: state.deleteClearingCounter + 1,
      };
      break;
    case CHANGE_STATUS_STRATEGY_START:
      state = {
        ...state,
        changeStatusLoading:true,
        changeStatusLoadingIndex: action.payload.index,
      };
      break;
    case CHANGE_STATUS_STRATEGY_END:
      state = {
        ...state,
        docs: state.docs.map((obj, index) => {
          if (index === action.payload.index && !action.payload.error) {
            obj.isActive = !obj.isActive;
          }
          return obj;
        }),
        changeStatusLoading: false,
      };
      break;
    default:
      state = { ...state };

  }
  return state;
};
export default leadReducer;